import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { SmoothScroll } from "./components/SmoothScroll";
import { Nav } from "./components/Nav";
import { JFooter as Footer } from "./components/jungle/JFooter";
import { CartDrawer } from "./components/CartDrawer";
import Home from "./pages/Home";
import PaymentSuccess, { PaymentCancel } from "./pages/PaymentSuccess";
import Cuadrante from "./pages/Cuadrante";
import Checkout from "./pages/Checkout";
import TransferPage from "./pages/TransferPage";
import AdminOrders from "./pages/AdminOrders";
import Account from "./pages/Account";
import ResetPassword from "./pages/ResetPassword";
import { CustomerProvider } from "./context/CustomerContext";
import { InstallBanner } from "./components/InstallBanner";

const FooterGate = () => (useLocation().pathname.startsWith("/cuadrante-riego") ? null : <Footer />);

function App() {
  return (
    <div className="App grain">
      <CustomerProvider>
      <CartProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/cuadrante-riego" element={<Cuadrante />} />
            <Route path="/finalizar-compra" element={<Checkout />} />
            <Route path="/pedido/transferencia" element={<TransferPage />} />
            <Route path="/pedidos" element={<AdminOrders />} />
            <Route path="/cuenta" element={<Account />} />
            <Route path="/cuenta/restablecer" element={<ResetPassword />} />
          </Routes>
          <FooterGate />
          <CartDrawer />
          <InstallBanner />
          <Toaster position="bottom-left" theme="dark" />
        </BrowserRouter>
      </CartProvider>
      </CustomerProvider>
    </div>
  );
}

export default App;
